import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'

export default class extends Controller {
  static targets = ['pageContent', 'desktopSidebar', 'mobileSidebar']

  connect() {
    requestAnimationFrame(() => {
      this.#toggleTooltips()
    })
  }

  toggleMobileSidebar() {
    this.mobileSidebarTarget.classList.toggle('unfolded')
  }

  async toggleDesktopSidebar() {
    patch('/users/settings', {
      body: JSON.stringify({
        settings: { desktop_sidebar_folded: !this.#isDesktopSidebarFolded() }
      }),
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      if (response.ok) {
        this.desktopSidebarTarget.classList.toggle('folded')
        this.pageContentTarget.classList.toggle('expanded')
        this.#toggleTooltips()
      }
    })
  }

  #isDesktopSidebarFolded() {
    return this.desktopSidebarTarget.classList.contains('folded')
  }

  #toggleTooltips() {
    const tooltipElements = this.#getTooltipElements()
    tooltipElements.forEach(tooltipElement => {
      const tooltipController = this.#getTooltipController(tooltipElement)
      if (tooltipController) this.#updateTooltipState(tooltipController)
    })
  }

  #getTooltipElements() {
    return this.desktopSidebarTarget.querySelectorAll(
      '[data-controller="primer--tooltip--component"]'
    )
  }

  #getTooltipController(tooltipElement) {
    return this.application.getControllerForElementAndIdentifier(
      tooltipElement,
      'primer--tooltip--component'
    )
  }

  #updateTooltipState(tooltipController) {
    if (this.#isDesktopSidebarFolded()) {
      tooltipController.enable()
    } else {
      tooltipController.disable()
    }
  }
}
